import React, {useState, useEffect, useRef} from "react"

function InputBox(props) {
    const inputRef = useRef(null)
    const [inputValue, setInputValue] = useState('')
    const [inputWidth, setInputWidth] = useState(".1rem")
    const [focus, setFocus] = useState(true)
    const [paused, setPaused] = useState(false)
    const [scrollingRight, setScrollingRight] = useState(true)

    const handleChange = (event) => {
        setInputValue(event.target.value)

        const offScreenElement = document.createElement("span")
        offScreenElement.style.position = "absolute"
        offScreenElement.style.top = "-9999px"
        offScreenElement.style.left = "-9999px"
        offScreenElement.style.whiteSpace = "pre"
        offScreenElement.style.font = window.getComputedStyle(inputRef.current).font
        document.body.appendChild(offScreenElement)
        offScreenElement.textContent = event.target.value
        setInputWidth(`${offScreenElement.offsetWidth}px`)
        document.body.removeChild(offScreenElement)
    }
      
    const handleKeyDown = (event) => {
        if (event.key === "Enter" && inputValue != '') {
            props.setPrompt(inputValue)
            props.showOptions()
            setFocus(false)
        }
    }

    const handleBlur = () => {
        if (focus && props.state === "start") inputRef.current.focus()
        else setFocus(false)
    }

    useEffect(() => {
    	if (props.state === "start" && !props.navOpen) inputRef.current.focus()
	    else setFocus(false)
    }, [props.navOpen])

    useEffect(() => {
        if (focus) inputRef.current.focus()
        else inputRef.current.blur()

        var scrollInterval
        const scrollText = () => {
            const element = inputRef.current
            if (!focus && element && element.scrollWidth > element.clientWidth) {
                const scrollSpeed = element.scrollWidth / 10
                if (!paused) {
                    if (scrollingRight) {
                        element.scrollLeft += scrollSpeed
                        if (element.scrollLeft >= element.scrollWidth - element.clientWidth) {
                            setScrollingRight(false)
                            setPaused(true)
                            setTimeout(() => setPaused(false), 1000)
                        }
                    } else {
                        element.scrollLeft -= scrollSpeed/2
                        if (element.scrollLeft <= 0) {
                            setScrollingRight(true)
                            setPaused(true)
                            setTimeout(() => setPaused(false), 1000)
                        }
                    }
                }
            }
        }

        if (!focus) scrollInterval = setInterval(scrollText, 10)
        else clearInterval(scrollInterval)
        return () => {clearInterval(scrollInterval)}
    }, [focus, paused, scrollingRight])

    return (
        <input ref={inputRef} type="text" style={{width: inputWidth}} id="inputbox" value={inputValue} onFocus={() => setFocus(true)} autoComplete="off" onChange={handleChange}  onBlur={handleBlur} onKeyDown={handleKeyDown}/>
    )
}

export default InputBox
